<template>
  <ul id="context-menu">
    <span class="close-button mdi mdi-close-circle mdi-24px" @click="closeContextMenu"></span>
    <p class="menu-title">メニュー</p>
    <ContextMenuItem><p class="not-copy menu-icon" @click="openModalSelect('robot')"><span class="mdi mdi-playlist-edit" style="margin-right: 5px;"></span>ロボを配置</p></ContextMenuItem>
    <!-- <ContextMenuItem><p class="not-copy menu-icon" @click="openModalSelect('sitDown')"><span class="mdi mdi-delete" style="margin-right: 5px;"></span>着席する</p></ContextMenuItem> -->
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import ContextMenuItem from '@/components/ui/ContextMenuItem'
export default {
  name: 'ContextMenuVirtualOffice',
  components: {
    ContextMenuItem
  },
  props: ['roomName'],
  methods: {
    openModalSelect (type) {
      this.$emit('openModalSelect', type)
      this.closeContextMenu()
    },
    closeContextMenu () {
      document.getElementById('context-menu').classList.remove('active')
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
#context-menu {
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  display: none;
  list-style: none;
  position: absolute;
  z-index: 2147483647;
  background-color: white;
  border: thin solid #00654C;
  border-bottom-width: 0px;
}
#context-menu.active {
  display: block;
}
.close-button {
  position: absolute;
  top: -6px;
  left: 107px;
}
.menu-icon {
  width: 100%;
  text-align: left;
  padding: 8px 15px;
}
.menu-title {
  font-weight: 600;
  text-align: left;
  padding: 8px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/ContextMenuVirtualOffice.vue